<app-modal
  [title]="
    data?.modalType === 'cancel' ? ('Cancellation Info' | trans:'description-modal/header/cancel-title') :
    data?.modalType === 'freeEntry' ? ('Reason for Free Entry' | trans:'description-modal/header/free-entry-title') :
    ('Description' | trans:'description-modal/header/title')
  "
  maxWidth="1200px"
  minWidth="30%"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div>
      <app-form-control
        label="{{ 'Remark' | trans:'description-modal/label' }}"
      >
        <textarea
          [(ngModel)]="description"
          height="150px"
          [placeholder]="
            data?.modalType === 'cancel' ? ('Enter cancellation remark' | trans:'description-modal/placeholder/cancel') :
            data?.modalType === 'freeEntry' ? ('Enter reason for free entry' | trans:'description-modal/placeholder/free-entry') :
            ('Enter description' | trans:'description-modal/placeholder')
          "
        ></textarea>
      </app-form-control>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel'| trans:'description-modal/cancel.Button' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase"
        (click)="confirm.emit({ description }); close()"
      >
        {{ 'Confirm'| trans:'description-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
